export const EditOptionComp = ({ row, setSelectedRow, openModal }) => {

    const handleEditClick = () => {
        setSelectedRow(row);
        openModal(true);
    }

    return (
        <i
            className="fa-solid fa-edit fs-6"
            onClick={handleEditClick}
            style={{
                color: '#2b97be',
                cursor: 'pointer',
            }}
            title='Ícone para abrir o modal de edição'
        />
    );
};